<script setup lang="ts">
import HeadingPrimary from '@/components/general/HeadingPrimary.vue';

interface Props {
  title?: string;
  buttonIcon?: string;
  buttonText?: string;
  buttonAction?: () => void;
  buttonActionLoading?: string;
  tooltip?: string;
  padding?: string;
  small?: boolean;
  UkButtonIcon?: string;
  medium?: boolean;
  headerInput?: string;
  input?: string;
  btnDisable?: boolean;
  closeButton?: boolean;
  buttonDataTid?: string;
}

defineProps<Props>();

const emit = defineEmits<{
  (event: 'inputChange', value: string): void;
  (event: 'closeImportModal'): void;
}>();
</script>

<template>
  <div class="container uk-card uk-card-default uk-border-rounded uk-margin">
    <HeadingPrimary
      :title="title"
      :buttonIcon="buttonIcon"
      :buttonText="buttonText"
      :buttonAction="buttonAction"
      :buttonActionLoading="buttonActionLoading"
      :tooltip="tooltip"
      :small="small"
      :medium="medium"
      :UkButtonIcon="UkButtonIcon"
      :headerInput="headerInput"
      :input="input"
      :btnDisable="btnDisable"
      :closeButton="closeButton"
      :buttonDataTid="buttonDataTid"
      @inputChange="emit('inputChange', $event)"
      @closeImportModal="emit('closeImportModal')"
    />
    <div
      :class="{
        'uk-padding': !padding,
        'main-container-table-padding': padding && padding !== 'none',
      }"
    >
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.main-container-table-padding {
  padding: 6px !important;
}
</style>
